import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { useApi } from '../api/contexto'
import type { ErrorApi } from '../api/errores'

/** Estado de una derivación en la bandeja de incidencias (B.6). */
export type EstadoDerivacion = 'pendiente' | 'gestionada' | 'descartada'

/** Una incidencia / petición fuera de bono que el agente derivó. */
export interface Derivacion {
  id: string
  canal: string // clientes | leads_castellon | leads_valencia
  sessionId: string | null
  contactId: string | null
  nombre: string | null
  telefono: string | null
  tipoCorreo: string
  motivo: string
  resumen: string | null
  estado: EstadoDerivacion
  correoEnviado: boolean
  creadaEn: string
  gestionadaEn: string | null
}

interface RespuestaDerivaciones {
  items: Derivacion[]
  total: number
}

/** Bandeja de incidencias. `estado` filtra (undefined = todas). */
export function useDerivaciones(estado?: EstadoDerivacion) {
  const api = useApi()
  return useQuery<RespuestaDerivaciones, ErrorApi>({
    queryKey: ['derivaciones', estado ?? 'todas'],
    queryFn: ({ signal }) =>
      api.pedir<RespuestaDerivaciones>('/api/derivaciones', {
        parametros: estado ? { estado } : undefined,
        senal: signal,
      }),
  })
}

/** Marca una derivación como gestionada / descartada / pendiente y refresca. */
export function useMarcarDerivacion() {
  const api = useApi()
  const qc = useQueryClient()
  return useMutation<unknown, ErrorApi, { id: string; estado: EstadoDerivacion }>({
    mutationFn: ({ id, estado }) =>
      api.pedir(`/api/derivaciones/${id}/marcar`, { metodo: 'POST', cuerpo: { estado } }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['derivaciones'] })
    },
  })
}
